import {useMemo} from 'react';

import {useBlogGridInlineCtaSuppressedByEditorial} from '@amblique/king-living/app/contentful/context/blog-grid-inline-cta-editorial-suppress';
import {resolveInlinedBlogGridCtaBlogSysId} from '@amblique/king-living/app/contentful/utils/blog-grid-inline-cta';
import {useBlogArticlePageBody} from '@amblique/king-living/app/hooks/use-blog-article-page-body';

/**
 * Blog Grid section CTA merges into a matching BlogSummary tile only on standalone blog article routes,
 * not on blog landing/listing or inside EditorialWrapper.
 *
 * @param {Pick<Contentful.Link, 'url'> | null | undefined} cta
 * @param {Array<object>} blogSummaries
 * @returns {string|null}
 */
export const useResolvedInlinedBlogGridCtaBlogSysId = (cta, blogSummaries) => {
  const suppressedByEditorial = useBlogGridInlineCtaSuppressedByEditorial();
  const isBlogArticlePage = useBlogArticlePageBody();

  return useMemo(() => {
    if (suppressedByEditorial || !isBlogArticlePage) return null;

    return resolveInlinedBlogGridCtaBlogSysId(cta, blogSummaries);
  }, [suppressedByEditorial, isBlogArticlePage, cta, blogSummaries]);
};
